import { Helmet } from "react-helmet-async";

const SITE = "https://diziteq.in";
const DEFAULT_IMG = "/generated/hero.png";

export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_IMG,
  schema,
  type = "website",
}) {
  const fullTitle = title
    ? `${title} | DiziTeQ Innovative Solutions`
    : "DiziTeQ Innovative Solutions | Digital Marketing Agency Bengaluru";
  const url = `${SITE}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="DiziTeQ Innovative Solutions" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
